export default "__VITE_ASSET__yMMag9Yp__"